<template>
	<div>
		<h2>{{ type }}</h2>
		<div class="dynvibeBox">
			<div v-if="loading" class="dynvibeLoading"></div>
			<div v-else-if="topics && Object.keys(topics).length > 0">
				<table class="table dynvibeTable">
					<thead>
						<tr>
							<th class="col-xs-2">Show</th>
							<th class="col-xs-4">Topics</th>
							<th v-if="type === 'tops'" class="col-xs-3">Acceleration</th>
							<th v-else class="col-xs-3">Deceleration</th>
							<th class="col-xs-1">Remove</th>
							<th class="col-xs-2">&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(item, index, key) in this.topics"
							:key="index"
							:class="{
								orange: this.toggleWaiting && isWaitingMastertagging(index),
								hidden: (!this.toggleWaiting && isWaitingMastertagging(index)) || (!this.toggleHidden && isHidden(index)),
								deleted: !allMastertags[index],
								trend: isATrend(index),
							}"
						>
							<td class="col-xs-2">
								<button
									class="btn openButton"
									@click="
										openTopic({
											topic: index,
											periodGrowth: item.posts,
											rank: key,
										})
									"
								>
									open
								</button>
							</td>
							<td class="col-xs-4">
								<span v-html="index"></span>
							</td>
							<td class="col-xs-3">
								{{ item.posts > 0 ? "+" + item.posts : item.posts }}
								%
							</td>
							<td class="col-xs-1">
								<div v-if="isHidden(index)">
									<span @click="showTopic(index)"><i class="fas fa-trash red"></i></span>
								</div>
								<div v-else>
									<span @click="hideTopic(index)"><i class="fas fa-trash black"></i></span>
								</div>
							</td>
							<td class="col-xs-2">
								<div v-if="isWaitingMastertagging(index)">Update in progress ...</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="row dynvibeRow">
					<div class="col-md-6">
						<span class="toggle-label">Display removed topics</span>
					</div>
					<div class="col-md-3">
						<span v-if="toggleHidden" @click="changeToggleHidden">
							<i class="fa toggle fa-toggle-on"></i>
						</span>
						<span v-else @click="changeToggleHidden">
							<i class="fa toggle fa-toggle-off"></i>
						</span>
					</div>
				</div>
				<div class="row dynvibeRow">
					<div class="col-md-6">
						<span class="toggle-label">Display topics processing</span>
					</div>
					<div class="col-md-3">
						<span v-if="toggleWaiting" @click="changeToggleWaiting">
							<i class="fa toggle fa-toggle-on"></i>
						</span>
						<span v-else @click="changeToggleWaiting">
							<i class="fa toggle fa-toggle-off"></i>
						</span>
					</div>
				</div>
			</div>
			<div v-else class="noData">
				<p>No Data to display</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "buzzinglist",
	//mixins: [mixin],
	props: {
		type: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		date: { gte: "", lte: "" },
		country: {
			type: String,
			default: "",
		},
		category: {
			type: String,
			default: "",
		},
		subcategory: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			loading: false,
			topics: {},
			//data: [],
			allMastertags: [],
			toggleHidden: false,
			toggleWaiting: false,
		};
	},
	methods: {
		checkFilters() {
			if (this.date.gte === "") {
				return;
			}
			this.loading = true;
			this.getData("topsFlops", {
				type: this.type,
				level: "mastertag",
				filters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					//removeUniqueTrend: 1, // remove mastertags where mastertags.trend.count == 1
				},
			});
		},
		openTopic(item) {
			this.$emit("clicked", item);
		},
		showTopic(item) {
			let params = { mastertag: item };
			this.$axios.post(this.$backendUrl + "showMastertag", this.$Qs.stringify(params)).then((response) => {
				this.allMastertags = response.data.mastertags;
			});
		},
		hideTopic(item) {
			let params = { mastertag: item };
			this.$axios.post(this.$backendUrl + "hideMastertag", this.$Qs.stringify(params)).then((response) => {
				this.allMastertags = response.data.mastertags;
			});
		},
		loadComponent() {
			if (this.date.gte === "") {
				return;
			}
			this.loading = true;
			this.getData("topsFlops", { type: this.type, level: "mastertag" });
		},
		treatResponse(response) {
			this.loading = false;
			this.allMastertags = response.data.mastertags;
			this.topics = response.data.evolution;
		},
		isHidden(label) {
			if (!this.allMastertags[label]) {
				return false;
			}
			return "hidden" in this.allMastertags[label] && this.allMastertags[label]["hidden"] === true;
		},
		isWaitingMastertagging(label) {
			if (!this.allMastertags[label]) {
				return false;
			}
			return "updated" in this.allMastertags[label];
		},
		isATrend(label) {
			if (!this.allMastertags[label]) {
				return false;
			}
			if (this.isWaitingMastertagging(label)) {
				// upcoming trend, so not hidden line but a orange one
				return false;
			}
			if (!("trends" in this.allMastertags[label])) {
				return false;
			}
			for (let i = 0; i < this.allMastertags[label]["trends"].length; i++) {
				let trend = this.allMastertags[label]["trends"][i];
				if (trend["count"] === 1) {
					return true;
				}
			}
			return false;
		},
		changeToggleWaiting() {
			this.toggleWaiting = !this.toggleWaiting;
		},
		changeToggleHidden() {
			this.toggleHidden = !this.toggleHidden;
		},
	},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date() {
			this.checkFilters();
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
	},
};
</script>

<style>
.dynvibeTable > thead > tr,
.dynvibeTable > tbody > tr {
	display: flow-root;
}

.fa-eye {
	font-size: 16px;
}

.fa-eye.visible {
	color: #46b132;
}

.hidden,
.deleted,
.trend {
	display: none !important;
}

.toggle {
	font-size: 20px;
	cursor: pointer;
	color: #46b132;
}

.toggle-label {
	font-weight: 400 !important;
	font-size: 14px;
	font-family: "Montserrat";
}

.orange {
	color: orange;
}

.red {
	color: #ef402d;
}

.black {
	color: #000;
}

.openButton {
	border: 1px solid #33d1cd;
	background-color: #fff;
	color: #33d1cd;
	padding: 2px 15px;
}

.openButton:hover,
.openButton:focus,
.openButton:focus-visible {
	outline: none !important;
	background-color: #33d1cd;
	color: #fff;
	padding: 2px 15px;
}
</style>
